<style type="text/css">
	.ws-block {
		padding-bottom: 15px;
	}
</style>
<template>
	<div class="ws-block">
		<fieldset style="border: 1px solid #ddd;" v-if="queryBlock">
			<legend>{{title}}</legend>
			<el-row style="padding-right: 5px;">
				<slot></slot>
			</el-row>
		</fieldset>

		<el-row v-if="!queryBlock">
			<slot></slot>
		</el-row>
	</div>
</template>
<script>
	export default {
		name: 'block',
		componentName: 'block',
		data() {
			return {};
		},
		props: {
			cols: Number, //列数
			labelWidth: String,
			queryBlock: {
				type: Boolean,
				default: true
			},
			title: {
				type: String,
				default: '查询条件'
			}
		},
		methods: {},
		created() {
			this.$on('el.block.addField', (field) => {
				// console.log('el.block.addField' + field);
				if (field) {
					// console.log('el.block.addField' + field);
				}
			});
			this.$on('el.block.removeField', (field) => {
				if (field.prop) {
					// console.log('el.block.removeField' + field);
				}
			});
		},
		mounted() {}
	};
</script>



// WEBPACK FOOTER //
// block.vue?01b8ea53